import { applyStyleModifiers } from 'styled-components-modifiers';
import styled from 'styled-components/macro';

export const modifiers = {
  alignStart: () => ({
    styles: `
      align-items: flex-start;
    `,
  }),
  alignCenter: () => ({
    styles: `
      align-items: center;
    `,
  }),
  alignEnd: () => ({
    styles: `
      align-items: flex-end;
    `,
  }),
  alignSelfStretch: () => ({
    styles: `
      align-self: stretch;
    `,
  }),
  row: () => ({
    styles: `
      flex-direction: row;
    `,
  }),
  rowReverse: () => ({
    styles: `
      flex-direction: row-reverse;
    `,
  }),
  justifyCenter: () => ({
    styles: `
      justify-content: center;
    `,
  }),
  justifyEnd: () => ({
    styles: `
      justify-content: flex-end;
    `,
  }),
  spaceBetween: () => ({
    styles: `
      justify-content: space-between;
    `,
  }),
  spaceAround: () => ({
    styles: `
      justify-content: space-around;
    `,
  }),
  spaceEvenly: () => ({
    styles: `
      justify-content: space-evenly;
    `,
  }),
  directionColumn: () => ({
    styles: `
      flex-direction: column;
    `,
  }),
  directionColumnReverse: () => ({
    styles: `
      flex-direction: column-reverse;
    `,
  }),
  wrap: () => ({ styles: 'flex-wrap: wrap;' }),
  flex1: () => ({
    styles: `
      flex: 1;
    `,
  }),
  flex0: () => ({
    styles: `
      flex: 0;
    `,
  }),
};

export default styled.div`
  display: flex;
  ${applyStyleModifiers(modifiers)};
`;
